// extracted by mini-css-extract-plugin
export default {"StyledReceipt":"init_StyledReceipt__ToiyS"};